import { useEffect, useRef, useState } from "react";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import ToolTip from "../common/ToolTip/ToolTip";
import Spinner from "../common/Spinner/spinner";
import { useDispatch, useSelector } from "react-redux";
import { departmentSelector } from "./selector";
import { useLocation, useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import { deleteDepartment, getDepartmentLists } from "./action";
import Modal from "../common/Modal/modal";

const DepartmentsList = () => {
  // redux dispatch initialize
  const dispatch = useDispatch();

  // config use to BaseURL
  const config = useConfiguration();

  // Navigate page
  const navigate = useNavigate();

  // department selector
  const { loadingFlag, departmentList } = useSelector(departmentSelector);

  // delete popup initialize
  const [deleteModal, setDeleteModal] = useState(false);

  // delete popup get a data
  const [deleteData, setDeleteData] = useState("");

  // close delete popup
  const closeDeletePopup = () => {
    setDeleteModal(false);
  };


  // Delete Department
  const deleteDepartmentId = () => {
    dispatch(deleteDepartment(config.baseUrl, deleteData?.candidateDepartmentId)).then(
      () => {
        dispatch(getDepartmentLists(config.baseUrl));
      }
    );
    closeDeletePopup();
  };

  const naigateCreateTeamsPageEdit = (department) => {
    navigate("/departments", {
      state: {
        pageTitle: "Edit Department",
        department,
        saveTitle: "Save",
      },
    });
  };

  useEffect(() => {
    if (config.baseUrl) {
      dispatch(getDepartmentLists(config.baseUrl));
    }
  }, [config.baseUrl]);

  // UI Side Pagination Section
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPageNum, setCurrentPageNum] = useState(1);
  // const [pageNo, setPageNo] = useState(100);
  const dataPerPage = useRef(50);
  const pageNumber = [];
  for (
    let i = 1;
    i < Math.ceil(departmentList?.length / dataPerPage.current) + 1;
    i++
  ) {
    pageNumber.push(i);
  }
  const indexOfLastItem = dataPerPage.current * currentPage;
  const indexOfCurrentItem = indexOfLastItem - dataPerPage.current;
  const DeptSearchCandidatesResults = departmentList?.slice(
    indexOfCurrentItem,
    indexOfLastItem
  );

  const pageNumPerPage = useRef(5);
  const indexOfLastPageNum = pageNumPerPage.current * currentPageNum;
  const indexOfCurrentPageNum = indexOfLastPageNum - pageNumPerPage.current;
  const currentNumberList = pageNumber?.slice(
    indexOfCurrentPageNum,
    indexOfLastPageNum
  );

  const prevHandler = (page) => {
    const newPage = page - 1;
    if (newPage <= indexOfCurrentPageNum) {
      setCurrentPageNum((prev) => prev - 1);
    }
    setCurrentPage(newPage);
  };
  const nextHandler = (page) => {
    const newPage = page + 1;
    if (newPage > indexOfLastPageNum) {
      setCurrentPageNum((prev) => prev + 1);
    }
    setCurrentPage(newPage);
  };
  const currentPageHandler = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      {loadingFlag > 0 && <Spinner />}
      <Header />
      <Sidebar />
      {deleteModal && (
        <Modal
          showHide={closeDeletePopup}
          saveFunction={deleteDepartmentId}
          label={"Delete"}
          size={"md"}
          onlyClose={false}
          buttonName={"Delete"}
        >
          <div className="text-center">Are you sure want to delete the {deleteData?.departmentName} department</div>
        </Modal>
      )}
      <div className="page main-margin">
        <div className="page-main">
          <div className="main-content app-content mt-0 main-background">
            <div className="side-app">
              <div className="main-container container-fluid">
                <div className="page-header">
                  <h1 className="page-title">Department List</h1>
                </div>
                {/* Departments List */}
                {departmentList?.length > 0 ? (
                  <div class="card">
                    <div class="card-body">
                      <div class="panel panel-primary">
                        <table className="table">
                          <thead>
                            <tr>
                              <th style={{ textTransform: "none" }}>
                                Department Name
                              </th>
                              <th style={{ textTransform: "none" }}>Active</th>
                              <th style={{ textTransform: "none" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {DeptSearchCandidatesResults?.map((item) => (
                              <tr>
                                <td>{item.departmentName}</td>
                                <td>{item.isActive ? "Yes" : "No"}</td>
                                <td>
                                  <div className="d-flex gap-4">
                                    <ToolTip
                                      position={"left"}
                                      value={"Edit Department"}
                                    >
                                      <i
                                        className="fa fa-edit fa-lg mt-1"
                                        style={{ cursor: "pointer" }}
                                        onClick={() =>
                                          naigateCreateTeamsPageEdit(item)
                                        }
                                      ></i>
                                    </ToolTip>
                                    <ToolTip
                                      position={"left"}
                                      value={"Delete Department"}
                                    >
                                      <i
                                        className="fe fe-trash-2 fa-lg"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          setDeleteModal(true);
                                          setDeleteData(item);
                                        }
                                          // deleteDepartmentId(
                                          //   item?.candidateDepartmentId
                                          // )
                                        }
                                      ></i>
                                    </ToolTip>
                                  </div>
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        {/* Pages Box with Search Page Form */}

                        <div className="col d-flex gap-3 justify-content-between">
                          <div className="">
                            {currentPage} of {pageNumber?.length} Pages
                          </div>
                          <nav aria-label="Page navigation example">
                            <ul class="pagination">
                              <li class="page-item">
                                <button
                                  class="page-link text-dark"
                                  href="#"
                                  disabled={currentPage === 1}
                                  onClick={() => prevHandler(currentPage)}
                                >
                                  Previous
                                </button>
                              </li>
                              {currentNumberList?.map((pgNum) => {
                                return (
                                  <li class="page-item">
                                    <button
                                      className={`page-link text-dark ${
                                        pgNum === currentPage
                                          ? "paginationPageColor"
                                          : ""
                                      }`}
                                      onClick={() => currentPageHandler(pgNum)}
                                    >
                                      {pgNum}
                                    </button>
                                  </li>
                                );
                              })}

                              <li class="page-item">
                                <button
                                  class="page-link text-dark"
                                  disabled={currentPage === pageNumber?.length}
                                  onClick={() => nextHandler(currentPage)}
                                >
                                  Next
                                </button>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div class="card">
                    <div class="card-body">
                      <div class="panel panel-primary">
                        <table className="table">
                          <thead>
                            <tr>
                              <th style={{ textTransform: "none" }}>
                                Department Name
                              </th>
                              <th style={{ textTransform: "none" }}>Active</th>
                              <th style={{ textTransform: "none" }}>Action</th>
                            </tr>
                          </thead>
                          <tbody></tbody>
                        </table>
                        <h2 className="text-center">No Departments Found</h2>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DepartmentsList;
